import { render, staticRenderFns } from "./asociar_evento.vue?vue&type=template&id=8f7f2c24"
import script from "./asociar_evento.vue?vue&type=script&lang=js"
export * from "./asociar_evento.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports